module.exports = __webpack_public_path__ + "static/media/nelsonmandela.90fafbfc.png";